import { HIDE_FROM_SCREENSHOTS_CLASS } from "@/components/r3f/utils/hide-from-screenshots-class";
import { grey } from "@faro-lotv/flat-ui";
import { alpha, Box } from "@mui/material";
import { type JSX } from "react";
import { useSmartNavigationStore } from "./smart-navigation-store";
import { SMART_NAVIGATION_CIRCLE_DIAMETER_RATIO } from "./use-smart-navigation";

/** Diameter of the smart navigation circle, in container query units of the 3D view */
const DIAMETER = `${SMART_NAVIGATION_CIRCLE_DIAMETER_RATIO * 100}`;

const BORDER_OPACITY = 0.6;
const BOX_SHADOW_OPACITY = 0.4;

/**
 * @returns The circle overlay of the smart navigation, or null when it should not be visible.
 *
 * The circle marks the two interaction areas of the smart navigation: left-dragging inside
 * the circle looks around like in a first person game, left-dragging outside orbits the camera.
 * The interaction itself, including when this circle is visible, is implemented in the
 * useSmartNavigation hook.
 */
export function SmartNavigationCircle(): JSX.Element | null {
  const shouldShowSmartNavigationCircle = useSmartNavigationStore(
    (state) => state.shouldShowSmartNavigationCircle,
  );

  if (!shouldShowSmartNavigationCircle) {
    return null;
  }

  return (
    <Box
      component="div"
      className={HIDE_FROM_SCREENSHOTS_CLASS}
      sx={{
        position: "absolute",
        inset: 0,
        containerType: "size",
        pointerEvents: "none",
      }}
    >
      <Box
        component="div"
        sx={{
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          width: `min(${DIAMETER}cqw, ${DIAMETER}cqh)`,
          aspectRatio: "1",
          borderRadius: "50%",
          border: `2px solid ${alpha(grey[0], BORDER_OPACITY)}`,
          // Dark halo around the white ring to keep it visible on bright scenes
          boxShadow: `0 0 4px ${alpha(grey[1300], BOX_SHADOW_OPACITY)}, inset 0 0 4px ${alpha(grey[1300], BOX_SHADOW_OPACITY)}`,
        }}
      />
    </Box>
  );
}
